import { SVGProps } from "react"
const SvgLogoRadancy = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 150 150">
        <defs>
            <linearGradient id="radancy-logo-gradient" x1="21.49" y1="131.5" x2="127.83" y2="23.42" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#860ff3"/>
                <stop offset="1" stopColor="#45bff5"/>
            </linearGradient>
        </defs>
        <path fill="none" d="M0,0H150V150H0Z" transform="translate(0 0)"/>
        <path fill="url(#radancy-logo-gradient)" d="M16.35,16.4v56h56v-56Zm47,22H38.06V63.59H25.63V25.9l37.73,0Zm-47,41.45v56h56v-56Zm21.71,47H25.63V89.14H38.06Zm41.62-47v56h56v-56Zm45.83,47a37.75,37.75,0,0,1-37.7-37.69h12.45a25.28,25.28,0,0,0,25.25,25.25ZM79.68,16.75v56h56v-56ZM115.09,63.4A25.27,25.27,0,0,0,89.84,38.15V25.7a37.75,37.75,0,0,1,37.7,37.7Z" transform="translate(0 0)"/>
    </svg>
)
export default SvgLogoRadancy
